import { useCollapsiblePersistentKeyboardDismissButtonVisible } from "@-/dev.improve.haniverse.components.collapsible-persistent-keyboard";
import { useDrillAnswerInputAutoFocus } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.answer-input-auto-focus";
import { AnswerInputRow } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.footer._components.answer-input-row";
import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { useIsRevealing } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.reveal";
import { useSubmitAnswer } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.submit";
import { useDrillPageAnswerMode } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.answer-mode";
import { useKeyboardState } from "@-/com.npmjs.react-native-keyboard-controller";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useEffect } from "react";
import { DrillFooterAnswerInputbox } from "#drill-footer-answer-inputbox";

export function DrillFooterMeaningView() {
  const [isAnswerModeOpen, drillKind] = useContextSelectors(
    DrillPageContext,
    (c) => c.isAnswerModeOpen,
    (c) => c.drillType.kind,
  );
  const { openAnswerMode } = useDrillPageAnswerMode();
  const submitAnswerMutation = useSubmitAnswer();
  const isRevealing = useIsRevealing();
  const isKeyboardVisible = useKeyboardState((s) => s.isVisible);
  const isDismissButtonVisible = useCollapsiblePersistentKeyboardDismissButtonVisible();
  const [answerInputValue] = useContextSelectors(DrillPageContext, (c) => c.keyboardText[0]);

  // Put the blinking cursor back in this card's input when arriving from the previous card's
  // rating with the keyboard still up (it only re-binds focus, never re-summons the keyboard).
  useDrillAnswerInputAutoFocus();

  useEffect(() => {
    if (isKeyboardVisible && !isAnswerModeOpen) {
      openAnswerMode();
    }
  }, [isAnswerModeOpen, isKeyboardVisible, openAnswerMode]);

  const isRevealPending = submitAnswerMutation.isPending || isRevealing;

  return (
    <AnswerInputRow
      accessibilityValue={answerInputValue}
      fillHeight
      isDismissButtonVisible={isDismissButtonVisible}
      isRevealButtonVisible={drillKind !== "meaning" || isDismissButtonVisible}
      onReveal={() => submitAnswerMutation.mutate()}
      revealDisabled={isRevealPending}
      revealLoading={isRevealPending}
    >
      <DrillFooterAnswerInputbox />
    </AnswerInputRow>
  );
}
